// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".next-payment-content[data-v-bb3079f2]{font-size:16px}.label[data-v-bb3079f2]{color:#777;font-size:14px}.creditcard-number[data-v-bb3079f2],.payment-creditcard[data-v-bb3079f2]{font-size:16px}", ""]);
// Exports
module.exports = exports;
